import React from "react";

export default function NoSavedCollectionsIcon({ ...props }: React.SVGProps<any>) {
  return (
    <svg width="66" height="61" viewBox="0 0 66 61" fill="none" {...props}>
      <path
        d="M7.25 0.875C5.50278 0.875 3.84103 1.4949 2.66797 2.66797C1.4949 3.84103 0.875 5.50278 0.875 7.25V15.75V24.25V49.75C0.875 51.4972 1.4949 53.159 2.66797 54.332C3.84103 55.5051 5.50278 56.125 7.25 56.125H49.75C51.4972 56.125 53.159 55.5051 54.332 54.332C55.5051 53.159 56.125 51.4972 56.125 49.75V26.375V24.25V20V15.75C56.125 14.0028 55.5051 12.341 54.332 11.168C53.159 9.9949 51.4972 9.375 49.75 9.375H26.375V7.25C26.375 5.50278 25.7551 3.84103 24.582 2.66797C23.409 1.4949 21.7472 0.875 20 0.875H7.25ZM7.25 5.125H20C20.8028 5.125 21.2627 5.35841 21.5772 5.67285C21.8916 5.98729 22.125 6.44722 22.125 7.25V9.375C22.125 10.4847 22.5274 11.6202 23.3286 12.4214C24.1298 13.2226 25.2653 13.625 26.375 13.625H49.75C50.5528 13.625 51.0127 13.8584 51.3272 14.1728C51.6416 14.4873 51.875 14.9472 51.875 15.75V18.2236C51.1988 18.0082 50.4868 17.875 49.75 17.875H20H15.75C14.0028 17.875 12.341 18.4949 11.168 19.668C9.9949 20.841 9.375 22.5028 9.375 24.25V28.5V32.75V49.75C9.375 50.5528 9.14159 51.0127 8.82715 51.3271C8.51271 51.6416 8.05278 51.875 7.25 51.875C6.44722 51.875 5.98729 51.6416 5.67285 51.3271C5.35842 51.0127 5.125 50.5528 5.125 49.75V24.25V15.75V7.25C5.125 6.44722 5.35842 5.98729 5.67285 5.67285C5.98729 5.35842 6.44722 5.125 7.25 5.125ZM15.75 22.125H20H49.75C50.5528 22.125 51.0127 22.3584 51.3272 22.6728C51.6416 22.9873 51.875 23.4472 51.875 24.25V26.375V49.75C51.875 50.5528 51.6416 51.0127 51.3272 51.3271C51.0127 51.6416 50.5528 51.875 49.75 51.875H13.2764C13.4918 51.1988 13.625 50.4868 13.625 49.75V32.75V28.5V24.25C13.625 23.4472 13.8584 22.9873 14.1729 22.6728C14.4873 22.3584 14.9472 22.125 15.75 22.125Z"
        fill="url(#paint0_linear)"
      />
      <rect x="23" y="28" width="43" height="33" rx="4" fill="url(#paint1_linear)" />
      <path
        d="M46.5825 46.4204L52.8514 46.4732C54.0053 46.4826 54.9484 45.5552 54.9581 44.4016C54.9683 43.2472 54.0405 42.3037 52.8859 42.2942L46.6177 42.2413L46.6701 35.973C46.6801 34.8185 45.7523 33.8749 44.5978 33.8657C43.4443 33.856 42.5011 34.7834 42.4911 35.9373L42.4386 42.2062L36.1697 42.1533C35.0162 42.1435 34.0726 43.0713 34.0626 44.2252C34.0528 45.3794 34.9806 46.3229 36.1348 46.3326L42.4035 46.3852L42.3506 52.6538C42.341 53.8081 43.2688 54.7516 44.4229 54.7612C45.5768 54.7706 46.5204 53.8427 46.53 52.6893L46.5825 46.4204Z"
        fill="white"
      />
      <defs>
        <linearGradient
          id="paint0_linear"
          x1="1.07213"
          y1="52.6252"
          x2="46.7359"
          y2="3.44112"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#084FE5" />
          <stop offset="1" stopColor="#28D094" />
        </linearGradient>
        <linearGradient
          id="paint1_linear"
          x1="23.1534"
          y1="58.9097"
          x2="49.0037"
          y2="22.6292"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#084FE5" />
          <stop offset="1" stopColor="#28D094" />
        </linearGradient>
      </defs>
    </svg>
  );
}
